'use strict';

module.exports = require('./dist/openchemlib-minimal');



//////////////////
// WEBPACK FOOTER
// ./~/openchemlib/minimal.js
// module id = 65
// module chunks = 0